module.exports = __webpack_public_path__ + "static/media/Alongamento.b98f4dc5.png";